import { STORAGE_KEY } from './STORAGE_KEY';

/**
 * Records in localStorage that the auto-conversation experiment has been fired.
 */
export const markAutoConversationFired = (): void => {
	try {
		// eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
		localStorage.setItem(STORAGE_KEY, 'true');
	} catch {
		// localStorage unavailable (e.g. private browsing quota exceeded) — silently ignore
	}
};
